import React, { DetailedHTMLProps, Ref, TextareaHTMLAttributes } from 'react';

import clsx from 'clsx';

import useRandomId from 'hooks/randomIdFallback';
import { removeWhiteSpace } from 'components/common/TextInput/textInput.utils';

import styles from './MultiLineInput.module.scss';

export type HTMLTextAreaProps = DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

interface CommonTextAreaProps {
  labelTitle?: string;
  errorMessage?: string;
  value?: string;
  containerClassName?: string;
}

export type TextAreaProps = CommonTextAreaProps & HTMLTextAreaProps & { inputRef?: Ref<HTMLTextAreaElement> };

const getFieldElement = (props: TextAreaProps): JSX.Element => {
  const { className, errorMessage, value: rawValue, inputRef, ...fieldProps } = props as TextAreaProps;
  const value = removeWhiteSpace(rawValue);
  const inputClassName = clsx(styles.input, errorMessage && styles.inputError, className);

  return <textarea className={inputClassName} value={value} {...fieldProps} ref={inputRef} />;
};

const MultiLineInput = ({
  id: providedId,
  labelTitle,
  errorMessage,
  containerClassName,
  ...restProps
}: TextAreaProps) => {
  const id = useRandomId(providedId);

  const fieldElement = getFieldElement({
    errorMessage,
    ...restProps,
    id,
  });

  return (
    <div className={clsx(styles.inputContainer, containerClassName)}>
      <div className={styles.labelWithLink}>
        <label htmlFor={id} className={styles.label}>
          {labelTitle}
        </label>
      </div>
      <div className={styles.fieldContainer}>{fieldElement}</div>
      {errorMessage && <p className={styles.errorNotification}>{errorMessage}</p>}
    </div>
  );
};

export default MultiLineInput;
